module.exports = __webpack_public_path__ + "static/assets/9ec3449723269a806ec6eaba0f8f6cef.ttf";